export const state = {
  theme: sessionStorage.theme ? sessionStorage.getItem("theme") : "light",
};

export const mutations = {
  CHANGE_THEME(state, theme) {
    state.theme = theme;
  },
};

export const actions = {
  changeTheme({ commit }, theme) {
    sessionStorage.setItem("theme", theme);
    return commit("CHANGE_THEME", theme);
  },
};
